import {Injectable} from '@angular/core';
import {environment} from '../../../environments/environment';
import {Helper} from '../../helpers/helper.service';
import {HttpClient} from '@angular/common/http';
import { catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class DownloadFilesService {
  constructor(private helper: Helper, private http: HttpClient) {
  }

  public manageDownloadFile(file, isEdit, id = null) {
    if (isEdit) {
      return this.http.put(environment.apiUrl + '/backoffice/download/files/' + id, file)
        .pipe(catchError(res => this.helper.catchError(res)));
    }
    return this.http.post(environment.apiUrl + '/backoffice/download/files/', file)
      .pipe(catchError(res => this.helper.catchError(res)));
  }

  deleteDownloadFile(id) {
    return this.http.delete(environment.apiUrl + '/backoffice/download/files/' + id)
      .pipe(catchError(res => this.helper.catchError(res)));
  }
}
